// IMAGES //
import the_80s from "../../assets/the_80s.jpg"

// COMPONENTS //
import SlideshowTJs from "../SlideshowTJs"

// STYLES // 
import "./faq.css"

export default function Faq() {
    return (
        <div id="faq" className="faq_text">

            <b>Q:  Do you use AI in your work? I noticed some em dashes and a few suspicious-looking sprites.</b>
            <p>A:  I do! It's great for spitballing and prototyping, especially when you're balancing creative work with a forty-hour-a-week day job and a (very) limited budget. But I don't consider any project finished until I've personally authored or art-directed all of the final content, whether created by me or in collaboration with other artists. And if AI accidentally liberates us from this global capitalist hellscape somewhere along the way, I suppose that'll free up even more time for drawing.</p>
            <p>As for those em dashes, we comic book artists have been using them since before AI was a thing—and probably before some people knew what an em dash was. They're great and I'm not giving them up.</p>

            <p className="faq_plus">+</p>

            <b>Q:  Why do you still code if AI can do it faster and better?</b>
            <p>A:  Because I love coding as much as I love drawing. I enjoy organizing my thoughts, building systems, solving problems, tracking down bugs, and gradually turning a concept into something that works.</p>

            <p>And, although I do love my AI assistant, I'm not going to stop doing what I love just because something else can do it faster. Riding a motorcycle is fun. Building one yourself, understanding how all the pieces fit together, and then taking it for a ride is a completely different experience.</p>

            <p>Would you stop doing something you love just because AI can do it faster?</p>

            <p className="faq_plus">+</p>

            <b>Q:  Wait, you paint signs for Trader Joe's? That's a real job?</b>
            <p>A:  Yes. Most Trader Joe's stores have one or more in-house artists who create the chalkboard signs, paint-marker displays, and murals you see throughout the store. I've created artwork for the Trader Joe's Wine Shop (RIP) in New York City and stores from Santa Barbara to Redondo Beach, with my favorite work hanging at the 3rd & Fairfax location in Los Angeles. It was an especially meaningful honor to paint a mural dedicated to the memory of Mely Corado at the Silver Lake store.</p>

            <SlideshowTJs />

            <p className="faq_plus">+</p>

            <b>Q:  What's your ethnic background?</b>
            <p>A:  The results from my sister's DNA tests were 64% Northwestern European and 36% Sub-Saharan African.  I'm assuming mine would be similar?</p>

        </div>
    )
}